import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import Representante from "model/fiscal/Representante";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import RepresentanteService from "service/fiscal/RepresentanteService";
import { cepMask, cnpjMask, cpfMask, phoneMask } from "utils/mask";

const representanteService = new RepresentanteService();

export default function RepresentanteCadastro() {
    const [representante, setRepresentante] = useState<Representante>(new Representante());
    const [erro, setErro] = useState("");

    function validar() {
        if (representante.codigoInterno == null) {
            setErro("Preencha o campo Código.");
            return false;
        }
        if (!representante.nome) {
            setErro("Preencha o campo Nome.");
            return false;
        }
        if (!representante.tipoPessoa) {
            setErro("Preencha o campo Tipo de pessoa.");
            return false;
        }
        if (!representante.numeroDocumento) {
            setErro("Preencha o campo CPF/CNPJ.");
            return false;
        }
        if (representante.numeroDocumento.replace(/\D/g, "").length !== (representante.tipoPessoa === "FISICA" ? 11 : 14)) {
            setErro("Informe um CPF ou CNPJ com a quantidade correta de dígitos.");
            return false;
        }
        if (representante.percentualComissaoPadrao < 0 || representante.percentualComissaoPadrao > 100) {
            setErro("A comissão deve estar entre 0 e 100%.");
            return false;
        }
        setErro("");
        return true;
    }

    return (
        <BaseCadastro model={representante} service={representanteService}
            setModel={(value: Representante) => setRepresentante(value)}
            getNewModel={() => new Representante()} novoCadastro
            validar={validar} pathCadastro="/representante" urlService="/representante" tituloPagina="Representante">
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">Representante</label>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    <Checkbox inputId="representante-ativo" checked={representante.ativo}
                        onChange={(e) => setRepresentante({ ...representante, ativo: !!e.checked })} />
                    <label htmlFor="representante-ativo" style={{ marginLeft: 8 }}>Ativo</label>
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Código</Label>
                    <InputNumber value={representante.codigoInterno} useGrouping={false}
                        maxFractionDigits={0}
                        onValueChange={(e) => { setRepresentante({ ...representante, codigoInterno: e.value ?? null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Nome</Label>
                    <InputText value={representante.nome ?? ""} maxLength={100}
                        onChange={(e) => { setRepresentante({ ...representante, nome: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Nome fantasia</Label>
                    <InputText value={representante.nomeFantasia ?? ""} maxLength={50}
                        onChange={(e) => { setRepresentante({ ...representante, nomeFantasia: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Tipo de pessoa</Label>
                    <Dropdown value={representante.tipoPessoa} options={representanteService.getListaTipoPessoa()}
                        optionLabel="label" optionValue="value"
                        onChange={(e) => { setRepresentante({ ...representante, tipoPessoa: e.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>CPF/CNPJ</Label>
                    <InputText value={representante.tipoPessoa === "FISICA"
                        ? cpfMask(representante.numeroDocumento ?? "")
                        : cnpjMask(representante.numeroDocumento ?? "")}
                        maxLength={representante.tipoPessoa === "FISICA" ? 14 : 18}
                        onChange={(e) => { setRepresentante({ ...representante, numeroDocumento: e.target.value.replace(/\D/g, "").slice(0, representante.tipoPessoa === "FISICA" ? 11 : 14) }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>RG</Label>
                    <InputText value={representante.rg ?? ""} maxLength={20}
                        onChange={(e) => { setRepresentante({ ...representante, rg: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Órgão emissor</Label>
                    <InputText value={representante.orgaoEmissorRg ?? ""} maxLength={10}
                        onChange={(e) => { setRepresentante({ ...representante, orgaoEmissorRg: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Inscrição estadual</Label>
                    <InputText value={representante.inscricaoEstadual ?? ""} maxLength={25}
                        onChange={(e) => { setRepresentante({ ...representante, inscricaoEstadual: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Inscrição municipal</Label>
                    <InputText value={representante.inscricaoMunicipal ?? ""} maxLength={20}
                        onChange={(e) => { setRepresentante({ ...representante, inscricaoMunicipal: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>E-mail</Label>
                    <InputText value={representante.email ?? ""} maxLength={254}
                        onChange={(e) => { setRepresentante({ ...representante, email: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Telefone</Label>
                    <InputText value={phoneMask(representante.telefone ?? "")} maxLength={15}
                        onChange={(e) => { setRepresentante({ ...representante, telefone: e.target.value.replace(/\D/g, "").slice(0, 11) || null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Logradouro</Label>
                    <InputText value={representante.logradouro ?? ""} maxLength={100}
                        onChange={(e) => { setRepresentante({ ...representante, logradouro: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Número</Label>
                    <InputText value={representante.numeroEndereco ?? ""} maxLength={20}
                        onChange={(e) => { setRepresentante({ ...representante, numeroEndereco: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Complemento</Label>
                    <InputText value={representante.complemento ?? ""} maxLength={100}
                        onChange={(e) => { setRepresentante({ ...representante, complemento: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Bairro</Label>
                    <InputText value={representante.bairro ?? ""} maxLength={75}
                        onChange={(e) => { setRepresentante({ ...representante, bairro: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Município</Label>
                    <InputText value={representante.municipio ?? ""} maxLength={60}
                        onChange={(e) => { setRepresentante({ ...representante, municipio: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>UF</Label>
                    <InputText value={representante.uf ?? ""} maxLength={2}
                        onChange={(e) => { setRepresentante({ ...representante, uf: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>CEP</Label>
                    <InputText value={cepMask(representante.cep ?? "")} maxLength={9}
                        onChange={(e) => { setRepresentante({ ...representante, cep: e.target.value.replace(/\D/g, "").slice(0, 8) || null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Comissão padrão (%)</Label>
                    <InputNumber value={representante.percentualComissaoPadrao} useGrouping={false}
                        minFractionDigits={0} maxFractionDigits={4}
                        onValueChange={(e) => { setRepresentante({ ...representante, percentualComissaoPadrao: e.value ?? 0 }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
            </div>
            {erro && <small className="p-error">{erro}</small>}
        </BaseCadastro>
    );
}
